import React from 'react';
import ApparatusItem from './ApparatusItem';

interface Apparatus {
  id: number;
  operating_instruction_id: number;
  name: string;
  instruction: string;
}

interface InfoApparatusListProps {
  apparatus: Apparatus[];
}

const InfoApparatusList: React.FC<InfoApparatusListProps> = ({ apparatus }) => {
  if (!apparatus || apparatus.length === 0) {
    return (
      <div className="mt-6">
        <h2 className="text-blue-600 font-semibold mb-4">Apparatus</h2>
        <p className="text-gray-500">No apparatus available.</p>
      </div>
    );
  }

  return (
    <div className="mt-6">
      <h2 className="text-blue-600 font-semibold mb-4">Apparatus</h2>
      {apparatus.map((item, i) => (
        <ApparatusItem key={item.id} index={i + 1} name={item.name} instruction={item.instruction} />
      ))}
    </div>
  );
};

export default InfoApparatusList;
